import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ kind: "polling", msg: "Verifying your payment…" });
  const attempts = useRef(0);
  const { refresh } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionId) { setState({ kind: "error", msg: "Missing session id" }); return; }

    const poll = async () => {
      if (attempts.current >= 10) { setState({ kind: "error", msg: "Payment status check timed out." }); return; }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState({ kind: "success", msg: "Payment received — your access is now active." });
          await refresh();
          return;
        }
        if (data.status === "expired") { setState({ kind: "error", msg: "This payment session expired." }); return; }
        setTimeout(poll, 2000);
      } catch (e) {
        setTimeout(poll, 2000);
      }
    };
    poll();
  }, [sessionId, refresh]);

  return (
    <div className="max-w-md mx-auto px-5 py-20">
      <div className="bg-white border border-[#E2DCD0] rounded-xl p-10 text-center">
        {state.kind === "polling" && <Loader2 className="w-12 h-12 mx-auto text-[#314A3E] animate-spin mb-4" />}
        {state.kind === "success" && <CheckCircle2 className="w-12 h-12 mx-auto text-[#314A3E] mb-4" />}
        {state.kind === "error" && <XCircle className="w-12 h-12 mx-auto text-[#B85C47] mb-4" />}
        <h1 className="text-2xl font-bold tracking-tight mb-3" style={{ fontFamily: "Outfit" }}>
          {state.kind === "success" ? "All set!" : state.kind === "error" ? "Hmm…" : "Just a moment"}
        </h1>
        <p className="text-stone-600 mb-6">{state.msg}</p>
        {state.kind === "success" && <Button data-testid="post-payment-dashboard-btn" onClick={() => navigate("/dashboard")} className="bg-[#314A3E] hover:bg-[#243a30] text-white">Go to dashboard</Button>}
        {state.kind === "error" && <Link to="/pricing"><Button variant="outline">Back to pricing</Button></Link>}
      </div>
    </div>
  );
}
